import React, {
  useRef,
  useLayoutEffect,
  useEffect,
  useState,
  useContext,
} from "react";

import LoadingContext from "../../context/Loading/Loading";
import authService from "../../utilities/services/auth.service";

import {
  getMySentTransfers,
  getMyReceivedTransfers,
  acceptIncomingTransfers,
  cancelMyTransfers,
} from "../../utilities/api";
import {
  fullHeightContainer,
  removeFullHeightContainer,
} from "../../utilities/helpers";

import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import { PageLoadingContainer } from "../PageLoadingContainer";
import TransferTable from "./TransferTable";

import "./myTransfersWrapper.scss";

export default function MyTransfersWrapper() {
  const user = authService.getUser();

  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext);

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  const [key, setKey] = useState("sent");

  const [show, setShow] = useState(false);

  const [ticketAction, setTicketAction] = useState("");

  const [transfers, setTransfers] = useState();

  const [transfer, setTransfer] = useState("");

  const [meta, setMeta] = useState();

  const [page, setPage] = useState(1);

  useLayoutEffect(() => {
    const el = document.querySelector("#main-container");
    const body = document.body;

    fullHeightContainer(el);
    body.classList.add("noBodyPadding");

    return () => {
      removeFullHeightContainer(el);
      body.classList.remove("noBodyPadding");
    };
  }, []);

  const getSendingTransfers = () => {
    showLoading();
    getMySentTransfers(user?.user?.email, page)
      .then((res) => {
        setTransfers(res.data?.data);
        setMeta(res.data.meta?.pagination);
        hideLoading();
      })
      .catch((err) => {
        hideLoading();
      });
  };

  const getReceivingTransfers = () => {
    showLoading();
    getMyReceivedTransfers(user?.user?.email, page)
      .then((res) => {
        setTransfers(res.data?.data);
        setMeta(res.data.meta?.pagination);
        hideLoading();
      })
      .catch((err) => {
        hideLoading();
      });
  };

  const acceptTransfer = (transfer) => {
    let data = {
      transferId: transfer.id,
    };

    acceptIncomingTransfers(data)
      .then((res) => getReceivingTransfers())
      .catch((err) => console.error(err));
  };

  const cancelTransfer = (transfer) => {
    let data = {
      transferId: transfer.id,
    };

    cancelMyTransfers({ data })
      .then((res) => getSendingTransfers())
      .catch((err) => console.error(err));
  };

  const handleShow = () => setShow(true);

  const handleClick = (action, transfer) => {
    setTransfer(transfer);
    handleShow();
    setTicketAction(action);
  };

  useEffect(() => {
    if (key === "sent") {
      getSendingTransfers();
    } else {
      getReceivingTransfers();
    }
  }, [page, key]);

  return (
    <>
      {isLoading ? (
        <PageLoadingContainer />
      ) : (
        <section className="spacer-xs" id="my-transfers-wrapper">
          <div className="section-heading-sm">
            <h1>My transfers</h1>
            {/* <div className="tablet-desktop-only">
              <SwiperNavigationButtons
                navigationPrevRef={navigationPrevRef}
                navigationNextRef={navigationNextRef}
              />
            </div> */}
          </div>
          <div className="d-flex-column position-relative">
            <Tabs
              defaultActiveKey="sent"
              variant="pills"
              activeKey={key}
              onSelect={(k) => {
                setKey(k);
                setPage(1);
              }}
            >
              <Tab eventKey="sent" title="Sent">
                <TransferTable
                  transfers={transfers}
                  meta={meta}
                  setPage={setPage}
                  currentKey={"sent"}
                  cancelTransfer={cancelTransfer}
                />
              </Tab>
              <Tab eventKey="received" title="Received">
                <TransferTable
                  transfers={transfers}
                  meta={meta}
                  setPage={setPage}
                  currentKey={"received"}
                  acceptTransfer={acceptTransfer}
                />
              </Tab>
            </Tabs>
          </div>
        </section>
      )}
    </>
  );
}
